import axios from 'axios'

const state = {
  user: null
}

const getters = {
  getUser: (state) => {
    return state.user
  }
}

const mutations = {
  setUser: function (state, user) {
    state.user = user
  }
}

const actions = {
  fetchUser: (context) => {
    return axios.get('/api/user/')
      .then(res => {
        context.commit('setUser', res.data)
        return res.data
      })
      .catch((err) => {
        context.commit('setUser', null)
        throw err
      })
  },
  logout: (context) => {
    return axios.get('/logout/')
      .then(res => {
        context.commit('setUser', null)
      })
      .catch((err) => {
        throw err
      })
  }
}

export default {
  strict: process.env.NODE_ENV !== 'production',
  state: {
    ...state
  },
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/app/store/modules/user.js